import { render, staticRenderFns } from "./SanVatForm.vue?vue&type=template&id=0d5009e1"
import script from "./SanVatForm.vue?vue&type=script&lang=js"
export * from "./SanVatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports